import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader.jsx";
import { SOCIAL_TRADING_RATINGS_URL } from "../../../../constants/platformRatings.js";
import PlatformRatingsIframe from "./PlatformRatingsIframe.jsx";

const SocialTradingRatings = () => {
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.user);
  const canView = Boolean(userDetails?.isCopyTradingEnable);

  useEffect(() => {
    if (userDetails?._id && !canView) {
      navigate("/dashboard", { replace: true });
    }
  }, [userDetails?._id, canView, navigate]);

  if (!userDetails?._id) return <Loader />;
  if (!canView) return null;

  return (
    <PlatformRatingsIframe
      src={SOCIAL_TRADING_RATINGS_URL}
      iframeTitle="Social trading ratings"
    />
  );
};

export default SocialTradingRatings;
